import { render } from "./DataDetails.vue?vue&type=template&id=a6f9f978"
import script from "./DataDetails.vue?vue&type=script&lang=js"
export * from "./DataDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__